
import React from "react";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import ExportDropdown from "./ExportDropdown";

interface DashboardHeaderProps {
  onExport: (type: string) => void;
  onLogout: () => void;
}

const DashboardHeader = ({ onExport, onLogout }: DashboardHeaderProps) => {
  return (
    <header className="flex justify-between items-center mb-8">
      <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
        7 for all Global Connect
      </h1>
      <div className="flex gap-2">
        <ExportDropdown onExport={onExport} />
        <Button
          variant="outline" 
          className="border-primary/20 hover:bg-primary/10 flex items-center gap-2"
          onClick={onLogout}
        >
          <LogOut size={16} />
          Odjava
        </Button>
      </div>
    </header>
  );
};

export default DashboardHeader;
